import React, {useEffect, useState} from 'react';
import {Field, Formik} from "formik";
import {getSpecialAdaptations} from "../../services/specialAdaptations-service";

export default function SpecialAdaptationsForm(props) {

    let [adaptationList, setAdaptationList] = useState([]);
    let [adaptationItems, setAdapatationItems] = useState([]);
    let [adaptationArray, setAdapatationArray] = useState([]);

    //When the component starts...
    useEffect(() => {
        //Request to get the adaptations.
        getSpecialAdaptations().then(data => {
            setAdaptationList(data);
        })
    }, []);

    const addAdaptation = (description, v2) => {
        adaptationItems.push(adaptationList.find(option => option.description == description));
        adaptationItems[adaptationItems.length - 1].amount = v2
        setAdapatationArray([...adaptationItems]);
        props.specialAdaptations(adaptationItems);
    }

    const deleteAdaptation = (index) => {
        adaptationItems.splice(index, 1);
        setAdapatationArray([...adaptationItems]);
        props.specialAdaptations(adaptationItems);
    }

    return (
        <>

            <Formik
                initialValues={{
                    description: '',
                    valueAdaptation: '',
                    specialAdaptationId: '',
                    status: '',
                    type: ''
                }} onSubmit={() => {
            }}>

                {({values, resetForm, handleChange}) => (

                    <div className="row mt-2">
                        <div className="col-6">
                            <div className="form-group">
                                <label>Adaptaciones especiales: </label>
                                <Field as="select" name="description" className="form-control form-select">
                                    <option value="" selected disabled>Seleccionar...</option>
                                    {adaptationList.map(option => (
                                        <option key={option.specialAdaptationId} value={option.description}>
                                            {option.description}
                                        </option>))}
                                </Field>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="form-group">
                                <label>Valor adaptación especial: </label>
                                <Field className="form-control" name="valueAdaptation" type="number"
                                       placeholder="00.00"
                                       required disabled={!values.description} onBlur={() => {
                                    if (values.valueAdaptation != "") {
                                        addAdaptation(values.description, values.valueAdaptation);
                                        resetForm();
                                    }
                                }}/>
                            </div>
                        </div>

                        <div>
                            <ul className="list-group">
                                {adaptationArray.map((adp, i) => (
                                    <div className="row" key={adp.specialAdaptationId}>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label>Adaptación: </label>
                                                <input disabled={true} className="form-control" type="text"
                                                       placeholder="00.00" value={adp.description}/>
                                                <small className="text-secondary"> Se añadió {adp.description}</small>
                                            </div>
                                        </div>
                                        <div className="col-4">
                                            <div className="form-group">
                                                <label>Valor: </label>
                                                <input disabled={true} className="form-control" type="text"
                                                       placeholder="00.00" value={adp.amount}/>
                                            </div>
                                        </div>
                                        <div className="col-2">
                                            <div className="mt-4 float-end">
                                                <button type="button" className="btn btn-skr-secondary text-light px-4"
                                                        onClick={() => deleteAdaptation(i)}
                                                        data-toggle="tooltip" title="Quitar adaptación especial">
                                                    <i className="bi-x-circle-fill"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </ul>
                        </div>
                    </div>
                    )}
            </Formik>
        </>

    );

}